import { render } from "./CardSocio.vue?vue&type=template&id=9ed4e5be"
import script from "./CardSocio.vue?vue&type=script&lang=ts"
export * from "./CardSocio.vue?vue&type=script&lang=ts"
script.render = render

export default script